export const BURNETT_API_ENDPOINT = "https://burnett-api.longjump.ai";
export const BURNETT_AUTH0_DOMAIN = "auth.longjump.ai";
export const BURNETT_AUTH0_CLIENT_ID = "YNb00ZRMBqPmDuIEC5chQELVBBOxzvrL";